import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TonConnectUIProvider } from '@tonconnect/ui-react';
import { useAuth } from '@/store/auth';
import { bootTelegram } from '@/lib/telegram';
import { startAnalytics } from '@/lib/analytics';
import { AppRouter } from './router';
import { Toast } from '@/components/Toast';

const TON_MANIFEST_URL = 'https://insight.x100.pro/tonconnect-manifest.json';

export default function App() {
  const hydrate = useAuth(s => s.hydrate);
  const login = useAuth(s => s.login);
  const status = useAuth(s => s.status);
  const token = useAuth(s => s.token);
  const user = useAuth(s => s.user);
  const { i18n } = useTranslation();

  useEffect(() => {
    bootTelegram();
    hydrate();
    // Если токена нет — логинимся через initData; иначе сразу готовы.
    if (status === 'idle' && !token) {
      void login().catch(() => { /* ошибка уже в сторе */ });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Стартуем аналитику один раз, когда авторизация готова (есть токен).
  useEffect(() => {
    if (status === 'ready') startAnalytics();
  }, [status]);

  // Синхронизируем язык интерфейса с lang юзера.
  useEffect(() => {
    if (user?.lang && i18n.language !== user.lang) {
      void i18n.changeLanguage(user.lang);
    }
  }, [user?.lang, i18n]);

  return (
    <TonConnectUIProvider manifestUrl={TON_MANIFEST_URL}>
      <AppRouter />
      <Toast />
    </TonConnectUIProvider>
  );
}
